import chata from '../Images/Photogallery/chata.jpeg';
import koupelna1 from '../Images/Photogallery/koupelna.jpeg';
import koupelna2 from '../Images/Photogallery/koupelna1.jpeg';
import koupelna3 from '../Images/Photogallery/sprchovy-kout.jpeg';
import kamna from '../Images/Photogallery/krbova-kamna.jpeg';
import kuchyn1 from '../Images/Photogallery/kuchyn.jpeg';
import kuchyn2 from '../Images/Photogallery/kuchynka.jpeg';
import kuchyn3 from '../Images/Photogallery/pohled-z-kuchyne.jpeg';
import podkrovi1 from '../Images/Photogallery/podkrovi-pokoj-mensi.jpeg';
import podkrovi2 from '../Images/Photogallery/pokoj-podkrovi.jpeg';
import pokoj from '../Images/Photogallery/pokoj-prizemi.jpeg';
import prichod from '../Images/Photogallery/prichod.jpeg';
import relax from '../Images/Photogallery/relax.jpeg';
import jidelna from '../Images/Photogallery/jidelna.jpeg';
import vyhledTerasa from '../Images/Photogallery/vyhled-z-terasy.jpeg';
import vyhledSkaly from '../Images/Photogallery/vyhled-na-skaly.jpeg';
import zahrada from '../Images/Photogallery/zahrada.jpeg';
import zahrada1 from '../Images/Photogallery/zahrada1.jpeg';
import zahrada2 from '../Images/Photogallery/zahrada2.jpeg';

const tileData = [
  { img: chata, title: 'Chata', cols: 1, },
  { img: prichod, title: 'Příchod', cols: 2, },
  { img: vyhledTerasa, title: 'Výhled z terasy', cols: 3, },
  { img: zahrada, title: 'zahrada', cols: 1, },
  { img: zahrada1, title: 'zahrada', cols: 1, },
  { img: zahrada2, title: 'zahrada', cols: 1, },
  { img: vyhledSkaly, title: 'terasa', cols: 3, },
  { img: relax, title: 'Relax', cols: 2, },
  { img: jidelna, title: 'Společenská místnost', cols: 1, },
  { img: kamna, title: 'kamna', cols: 1, },
  { img: kuchyn2, title: 'kuchyn2', cols: 1, },
  { img: kuchyn1, title: 'kuchyn1', cols: 1, },
  { img: kuchyn3, title: 'kuchyn3', cols: 3, },
  { img: koupelna1, title: 'koupelna1', cols: 1, },
  { img: koupelna2, title: 'koupelna2', cols: 1, },
  { img: koupelna3, title: 'Sprchový kout', cols: 1, },
  { img: podkrovi1, title: 'podkrovi1', cols: 1, },
  { img: podkrovi2, title: 'podkrovi2', cols: 1, },
  { img: pokoj, title: 'pokoj', cols: 1, },
 ];

 export default tileData;